import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

import './Styles.css';

class ClienteTaxInfo extends Component {
  render() {
    const { data = {}, children } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-info card-label-info">ID: </strong>
          { data.id }
          <br/>

          <strong className="text-info card-label-info">Razón social: </strong>
          { data.razon_social }
          <br/>

          <strong className="text-info card-label-info">RFC: </strong>
          { data.rfc }
          <br/>

          <strong className="text-info card-label-info">Contacto: </strong>
          { data.contacto } / { data.telefono }
          <br/>

          { children }

          </Card.Body>
      </Card>
    )
  }
}

export default ClienteTaxInfo;